import {
	channelByID,
	channelCreate,
	channelDestroy,
	channelList,
	channelUpdate,
} from '@/services/agency/ad-channels.service'

export default {
	namespaced: true,
	state: {
		// SERVICE CHANNEL
		channelList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		channel: {},

		// STATUS SERVICE CHANNEL
		channelStatus: 'pending',
		channelSaveStatus: 'init',
		channelDeleteStatus: 'init',
	},
	getters: {
		// SERVICE CHANNEL
		getChannelList(state) {
			return state.channelList
		},
		getChannel(state) {
			return state.channel
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE CHANNEL
		getChannelDeleteStatus(state) {
			return state.channelDeleteStatus
		},
		getChannelSaveStatus(state) {
			return state.channelSaveStatus
		},
		getChannelStatus(state) {
			return state.channelStatus
		},
	},
	mutations: {
		// SERVICE CHANNEL
		CHANNEL_LIST(state, value) {
			state.channelList = value
		},
		SET_CHANNEL(state, value) {
			state.channel = value
		},

		// STATUS SERVICE CHANNEL
		CHANNEL_STATUS(state, value) {
			state.channelStatus = value
		},
		CHANNEL_SAVE_STATUS(state, value) {
			state.channelSaveStatus = value
		},
		CHANNEL_DELETE_STATUS(state, value) {
			state.channelDeleteStatus = value
		},
	},
	actions: {
		// Service Channel
		async fetchChannelList({ commit }, params) {
			commit('CHANNEL_STATUS', 'pending')
			commit('CHANNEL_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await channelList(params)
				commit('CHANNEL_STATUS', 'init')
				commit('CHANNEL_LIST', data)
				return data
			} catch (error) {
				commit('CHANNEL_STATUS', 'init')
				throw error
			}
		},
		async fetchChannelByID({ commit }, params) {
			commit('CHANNEL_STATUS', 'pending')
			try {
				const { data } = await channelByID(params)
				commit('CHANNEL_STATUS', 'init')
				commit('SET_CHANNEL', data.data)
				return data
			} catch (error) {
				commit('CHANNEL_STATUS', 'init')

				return error
			}
		},
		async saveNewChannel({ commit }, params) {
			commit('CHANNEL_SAVE_STATUS', 'pending')
			try {
				const { data } = await channelCreate(params)
				commit('CHANNEL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CHANNEL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateChannel({ commit }, params) {
			commit('CHANNEL_SAVE_STATUS', 'pending')
			try {
				const { data } = await channelUpdate(params)
				commit('CHANNEL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CHANNEL_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteChannelByID({ commit }, params) {
			commit('CHANNEL_DELETE_STATUS', 'pending')
			try {
				const { data } = await channelDestroy(params)
				commit('CHANNEL_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CHANNEL_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
